{
  "ui": {
    "feedback": "Feedback",
    "credits": "Makers",
    "currentMaintainer": "Huidige beheerder",
    "maintainerPeriod": "Vanaf 2026",
    "originalTeam": "Oorspronkelijk team",
    "creditsCampaigns": "Jungle & Kerstmis",
    "moreSettings": "Meer instellingen",
    "chooseLanguage": "Kies je taal",
    "notebookTools": "Gereedschap voor je schrift",
    "visualGuide": "Uitleg in plaatjes",
    "templeSoon": "Binnenkort",
    "playAdventure": "Spelen",
    "story": "Het verhaal",
    "loadingAdventure": "We pakken in voor het avontuur…",
    "storyOpening": "Een schoolreisje naar de jungle. Marco en Sophia gaan met hun vrienden op ontdekking. Marco ziet een kleurrijke vogel en volgt hem tussen de bomen. Opeens is hij alleen. Help de ontdekkers de weg te vinden!",
    "storyEnding": "Marco en Sophia bereiken samen de verloren tempel. Een geheimzinnig gezicht bewaakt de ingang. Er wacht een nieuw avontuur!",
    "blockCategories": "Tabbladen van je schrift",
    "actions": "Acties",
    "loops": "Lussen",
    "conditions": "Voorwaarden",
    "title": "Run Marco! — Een avontuur in je schrift",
    "home": "Run Marco startpagina",
    "map": "Avonturenkaart",
    "worlds": "Kies een avontuur",
    "notebook": "Mijn schrift",
    "notebookToggle": "Schrift openen of sluiten",
    "notebookOpen": "Schrift openen",
    "notebookClose": "Kijk naar het pad",
    "page": "Pagina {number}",
    "level": "Route {number}",
    "run": "Daar gaan we!",
    "stop": "Stoppen",
    "step": "Eén stap",
    "stepTitle": "Eén opdracht uitvoeren",
    "reset": "Terug naar de start",
    "add": "Toevoegen",
    "addLabel": "Kies een blok om toe te voegen",
    "addHint": "Maak je blokken aan elkaar vast en druk op Spelen.",
    "undo": "Ongedaan maken",
    "clear": "Nieuwe pagina",
    "hint": "Een kleine hint",
    "help": "Zo speel je",
    "settings": "Instellingen",
    "language": "Taal van het spel",
    "blockLanguage": "Taal van de blokken",
    "blockLanguageNote": "Je kunt voor de blokken een andere taal kiezen.",
    "musicOn": "Geluid aan",
    "musicOff": "Geluid uit",
    "sound": "Muziek en geluidseffecten",
    "speed": "Snelheid van het avontuur",
    "chooseExplorer": "Kies je ontdekker",
    "explorer": "Ontdekker",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Sluiten",
    "done": "Op ontdekking!",
    "loading": "We zoeken het pad…",
    "loadError": "Het avontuur kon niet laden. Laad de pagina opnieuw om het nog eens te proberen.",
    "imageError": "Sommige plaatjes konden niet laden. Laad de pagina opnieuw.",
    "gemGoal": "Vind de edelsteen",
    "goal": "Vind de gouden ster",
    "cover": "Laat elk vakje precies één keer oplichten",
    "lit": "{count} / {total} vakjes verlicht",
    "explored": "{count} / {total} routes ontdekt",
    "facing": "Kijkt naar {direction} {arrow}",
    "boardLabel": "{name} op {level}, kijkt naar {direction}. {steps}. {objective}.",
    "up": "boven",
    "down": "beneden",
    "left": "links",
    "right": "rechts",
    "steps_one": "{count} stap",
    "steps_other": "{count} stappen",
    "blocks_one": "{count} blok",
    "blocks_other": "{count} blokken",
    "stars_one": "{count} ster",
    "stars_other": "{count} sterren",
    "place": "Blokken toevoegen",
    "atEnd": "Aan het einde",
    "insideRepeat": "In herhaal {number}",
    "insideIf": "In als {number}",
    "insideElse": "In anders {number}",
    "readyFirst": "Een klein stapje. Voeg een vooruitblok toe en daar gaan we!",
    "ready": "Waar gaan we heen? Maak een plan in je schrift.",
    "back": "Terug bij de start. Je blokken zijn klaar voor een nieuwe poging.",
    "empty": "Voeg eerst een blok toe aan je schrift.",
    "win": "Je hebt de weg gevonden!",
    "winCover": "Je hebt het pad verlicht!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "Wat een avontuur!",
    "simpler": "Kun je minder blokken gebruiken?",
    "complete": "Route voltooid! Je beste sterren zijn opgeslagen.",
    "next": "Volgende route",
    "allWorlds": "Meer avonturen",
    "replay": "Opnieuw spelen",
    "shortGoal": "Bijna! Voeg nog wat blokken toe om de ster te bereiken.",
    "shortGem": "Bijna! Voeg nog wat blokken toe om de edelsteen te bereiken.",
    "shortCover": "Sommige vakjes zijn nog donker. Hoe komen we daar?",
    "checking": "We bekijken het pad…",
    "paused": "Gestopt. Spelen begint weer bij het begin.",
    "going": "Op pad!",
    "stepped": "Een stapje dichterbij. Druk op Eén stap of Spelen om verder te gaan.",
    "clueCover": "Begin aan een rand en volg de hele vorm. Je kunt over een vakje springen zonder het te verlichten.",
    "clueCondition": "Kijk naar het pad voor je. Een voorwaarde helpt je ontdekker te kiezen wat hij doet.",
    "clueRepeat": "Welke stappen komen steeds terug? Zet dat patroon in een herhaalblok.",
    "clueForward": "Vooruit volgt de kijkrichting van je ontdekker. Tel de vakjes tot de ster.",
    "clueGem": "Vooruit volgt de kijkrichting van je ontdekker. Tel de vakjes tot de edelsteen.",
    "clueTurn": "Draaien verandert de richting zonder vooruit te gaan. Volg het pad met je vinger.",
    "mapNote": "Kies een route. Je beste sterren blijven bewaard.",
    "mapLevel": "Route {number}: {name}. {stars}.",
    "locked": "Voltooi de vorige route om deze vrij te spelen.",
    "soundBlocked": "Tik op de geluidsknop om het avontuur te horen.",
    "clearTitle": "Beginnen op een nieuwe pagina?",
    "clearNote": "Dit wist je blokken voor deze route. Ongedaan maken kan ze terughalen.",
    "keep": "Mijn blokken houden",
    "clearConfirm": "Blokken wissen",
    "fresh": "Een nieuwe pagina. Waar brengt je volgende plan ons?",
    "localProgress": "Je voortgang wordt op dit apparaat opgeslagen.",
    "helpBuild": "Maak een plan",
    "helpBuildText": "Sleep blokken naar je schrift en verbind ze, of tik op een blok om het toe te voegen. Kies ‘In herhaal’ voor stappen in een lus.",
    "helpTurn": "Volg je ontdekker",
    "helpTurnText": "Vooruit volgt zijn kijkrichting. Links en rechts draaien op dezelfde plek. Een sprong gaat twee vakjes ver.",
    "helpTry": "Probeer, kijk, probeer opnieuw",
    "helpTryText": "Druk op Spelen voor je plan of Eén stap voor één opdracht. De gebogen pijl brengt je terug naar de start en bewaart je blokken.",
    "helpWorlds": "Elk avontuur heeft een doel",
    "helpWorldsText": "Vind de edelsteen in de Jungle. Verlicht met Kerstmis elk vrij vakje één keer. Voltooi in de Tempel en de Egeïsche Zee de reparaties en zichtbare doelen en bereik de uitgang.",
    "noTrail": "Daar is geen pad! Probeer eerst te draaien.",
    "broken": "Die brug is kapot. Kun je eroverheen springen?",
    "blocked": "Er staat iets in de weg. Probeer een sprong of een andere route.",
    "alreadyLit": "Dat vakje is al verlicht. Bezoek elk vakje maar één keer.",
    "loopError": "Dit plan blijft zich herhalen. Probeer de lus te veranderen.",
    "repeatError": "Kies een aantal herhalingen van 1 tot 99.",
    "unsupported": "Verwijder het niet-ondersteunde blok en probeer opnieuw.",
    "connect": "Verbind je blokken tot één ketting en druk op Spelen.",
    "path": "pad",
    "backpack": "Rugzak",
    "templeGems": "Edelstenen van de tempel",
    "gemsCollected": "Edelstenen: {count} / {total}",
    "gemsReady": "Alle edelstenen zijn verzameld!",
    "aegeanTitle": "De geheimen van de Egeïsche Zee",
    "harbour": "Haven",
    "aegeanDescription": "Verken de haven: herstel werkstations, hergebruik routines en geef bij elke opdracht een getal mee.",
    "templeBetaNote": "Bèta · We werken de puzzels en lessen bij",
    "aegeanBetaNote": "Bèta · De eerste 3 havenlevels",
    "seasonal": "Seizoensavontuur",
    "choosePreview": "Kies een voorbeeldlevel",
    "repairs": "Reparaties",
    "reachExit": "Bereik de uitgang",
    "taskRequirements": "Missiedoelen",
    "lessonGuided": "Begeleide oefening · maak het gegeven programma af",
    "lessonRepair": "Fouten opsporen · verbeter het gegeven programma",
    "lessonChallenge": "Uitdaging · maak je eigen programma",
    "acc_define_parameter": "Routine",
    "acc_call_argument": "Routine aanroepen",
    "acc_repeat_parameter": "Herhalen met invoer",
    "parameter": "parameter",
    "argument": "meegeven",
    "callInput": "Invoer van deze aanroep",
    "inputWaiting": "Start het programma of voer één instructie uit om de volgende invoer te zien.",
    "argumentMismatch": "Een routine met een parameter heeft een aanroep met een getal nodig. Zonder parameter gebruik je een gewone aanroep.",
    "unsetParameter": "Gebruik de parameter alleen in de routine die hem ontvangt. Parameters staan los van het gedeelde geheugen.",
    "memoryObjective": "Controleer het reparatieoverzicht en de uitgangsdoelen. Elk programma dat eraan voldoet wordt geaccepteerd.",
    "gate": "De doorgang is geblokkeerd. Controleer de onvoltooide reparaties.",
    "noPickup": "Ga op het gereedschap staan voordat je het oppakt.",
    "creditLead": "Teamleiding en softwareontwikkeling",
    "creditArt": "Illustraties en decors",
    "creditAnimation": "Animatie",
    "creditUX": "Interface- en gebruikerservaringsontwerp",
    "creditDesign": "Spelontwerp",
    "creditStory": "Verhaal",
    "creditAudio": "Muziek en geluidstechniek",
    "lightLamp": "Lamp aansteken",
    "oilLamp": "Olielamp",
    "dustyStation": "stoffig werkstation",
    "betaLabel": "Bèta",
    "noLamp": "Ga op een gedoofde lamp staan voordat je haar aansteekt.",
    "collected": "Gereedschap gepakt · klaar voor gebruik",
    "dustyPrompt": "Ga op een stoffig station staan voordat je de kwast gebruikt.",
    "lampMissing": "Pak eerst de olielamp. Kijk in je rugzak.",
    "recursiveRoutine": "Deze routine roept zichzelf aan. Gebruik een andere routine; recursieve aanroepen zijn nog niet beschikbaar."
  },
  "content": {
    "jungle.title": "Jungletocht",
    "jungle.description": "Volg het pad naar de verloren tempel.",
    "jungle-1": "Eerste stappen",
    "jungle-2": "Een stukje verder",
    "jungle-3": "Om de hoek",
    "jungle-4": "Verander van richting",
    "jungle-5": "Volg het pad",
    "jungle-6": "Een nieuwe route",
    "jungle-7": "Nieuwe paden",
    "jungle-8": "Kruispunt in de jungle",
    "jungle-9": "Vind je weg",
    "jungle-10": "Denk vooruit",
    "jungle-11": "Het lange pad",
    "jungle-12": "Een kronkelende route",
    "jungle-13": "Een dappere sprong",
    "jungle-14": "Er verschijnen patronen",
    "jungle-15": "Herhaal het ritme",
    "jungle-16": "Kies een pad",
    "jungle-17": "Kijk voordat je springt",
    "jungle-18": "Lees het pad",
    "jungle-19": "Een slimme omweg",
    "jungle-20": "Onder de boomtoppen",
    "jungle-21": "Bruggenbouwer",
    "jungle-22": "Voorbij de rivier",
    "jungle-23": "Ontdek de ruïnes",
    "jungle-24": "Steen en hout",
    "jungle-25": "Een grotere sprong",
    "jungle-26": "Volg de aanwijzingen",
    "jungle-27": "Hogerop",
    "jungle-28": "Blijf ontdekken",
    "jungle-29": "Kronkelpaden",
    "jungle-30": "De geheime tuin",
    "jungle-31": "Verborgen patronen",
    "jungle-32": "Eeuwenoude paden",
    "jungle-33": "De laatste bochten",
    "jungle-34": "Naar de tempel",
    "jungle-35": "Bijna daar",
    "jungle-36": "De verloren tempel",
    "winter.title": "Winterpad",
    "winter.description": "Laat elke voetafdruk oplichten.",
    "winter-1": "Stappen in de sneeuw",
    "winter-2": "Een andere richting",
    "winter-3": "Bevroren hoeken",
    "winter-4": "De lange omweg",
    "winter-5": "Sneeuwvlok",
    "winter-6": "Winterlussen",
    "winter-7": "IJsontdekker",
    "winter-8": "Bochten en kronkels",
    "winter-9": "IJzige logica",
    "winter-10": "Patroonzoeker",
    "winter-11": "Meester van het pad",
    "winter-12": "Winterwonder",
    "temple.title": "De verloren tempel",
    "temple.description": "Veertig verbonden kamers: herstel een hemelinstrument met gereedschap, geheugen en eigen routines."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Prullenbak, nu leeg",
    "OPEN_TRASH": "Prullenbak openen",
    "BLOCK_LABEL_BEGIN_STACK": "Begin van de stapel",
    "WORKSPACE_LABEL_1_STACK": "1 stapel blokken",
    "WORKSPACE_LABEL_MANY_STACKS": "%1 stapels blokken",
    "ARIA_TYPE_FIELD_NUMBER": "getal",
    "ARIA_TYPE_FIELD_DROPDOWN": "keuzelijst",
    "ARIA_TYPE_FIELD_IMAGE": "afbeelding",
    "WORKSPACE_LABEL_PLAIN": "Mijn schrift",
    "FIELD_LABEL_EDIT_PREFIX": "%1 bewerken",
    "BLOCK_LABEL_HAS_INPUT": "heeft invoer",
    "BLOCK_LABEL_HAS_INPUTS": "heeft invoervelden",
    "BLOCK_LABEL_HAS_BRANCHES": "heeft %1 takken",
    "FIELD_LABEL_OPTION_INDEX": "Optie %1",
    "INPUT_LABEL_EMPTY": "Leeg",
    "BLOCK_LABEL_DISABLED": "uitgeschakeld",
    "BLOCK_LABEL_COLLAPSED": "ingeklapt",
    "BLOCK_LABEL_BEGIN_PREFIX": "Begin: %1",
    "INPUT_LABEL_END_STATEMENT": "Einde: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "tekst",
    "ARIA_TYPE_FIELD_INPUT": "invoer",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "naam van invoer",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "naam van routine"
  }
}
